/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from "react";
import { useAccount, useNetwork } from "wagmi";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";

export const AppContext = createContext(null);

const AppRootContext = ({ children }) => {
  const [walletSidebarOpen, setWalletSidebarOpen] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [isSignWallet, setIsSignWallet] = useState(
    localStorage?.getItem("wagmai_signature")?true: false
  );

  const isMobile = useMediaQuery({ query: "(max-width: 1180px)" });
  const { connector } = useAccount();
  const { chain } = useNetwork();

  const { pathname } = useLocation();

  const handleToggleWalletSidebar = () => {
    setWalletSidebarOpen((prev) => !prev);
  };

  const handleSignWallet = (isSign) => {
    setIsSignWallet(isSign);
  };

  useEffect(() => {
    connector
      ?.getChainId()
      .then((id) => {
        console.log(id, "chainId");
        setSelectedNetwork(Number(id));
      })
      .catch((err) => {
        console.log(err, "chainerr");
      });
  }, [connector, chain?.id]);

  useEffect(() => {
    if (isMobile) {
      if (pathname !== "/") {
        setTimeout(() => {
          const a = document.createElement("a");
          a.href = document.location.origin;
          a.click();
        }, 1000);
      }
    }
  }, []);

  return (
    <>
      <AppContext.Provider
        value={{
          isSignWallet,
          selectedNetwork,
          walletSidebarOpen,
          handleSignWallet,
          handleToggleWalletSidebar,
        }}
      >
        {children}
      </AppContext.Provider>
    </>
  );
};

export default AppRootContext;

export const useRootContext = () => {
  const {
    isSignWallet,
    selectedNetwork,
    walletSidebarOpen,
    handleSignWallet,
    handleToggleWalletSidebar,
  } = useContext(AppContext);

  return {
    isSignWallet,
    selectedNetwork,
    walletSidebarOpen,
    handleSignWallet,
    handleToggleWalletSidebar,
  };
};
